/**
 * Enhancements for the social media sharing buttons in the article template.
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';

/**
 * Add twitter handle to twitter button.
 *
 * @return {void}
 */
export function addTwiterHandle()
{
    $$('.abh_twitter').filter(el => el.nodeName === 'A' && el.href).forEach(el => {
        const handle = el.href.split( '/' ).pop();
        el.insertAdjacentHTML(
            'beforeend',
            `<img class="dashicons" src="https://upload.wikimedia.org/wikipedia/commons/5/53/X_logo_2023_original.svg" alt="">
            <span class="handle">@${ handle }</span>`
        );
    });
}

/**
 * Add class telling the CSS if there is an author image.
 *
 * @return {void}
 */
export function addImageClass()
{
    const images = document.querySelectorAll('.abh_image img');
    const metaBox = document.querySelector('.author-and-post-info');

    if (metaBox) {
        metaBox.classList.add((images.length ? 'has' : 'no') + '-image');
    }
}
